/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";

const ChartLine = props => {
  const [chart, setChartData] = useState({});
  const [displayTitle] = useState(true);
  const [displayLegend] = useState(true);
  var [legendPosition] = useState("right");
  var [location] = useState("City");

  if (props.location != null) {
    location = props.location;
  }
  if (props.legendPosition != null) {
    legendPosition = props.legendPosition;
  }

  const chartData = () => {
    setChartData(props.chartData);
  };

  useEffect(() => {
    chartData();
  });

  return (
    <div className="chart">
      <Line
        data={chart}
        options={{
          title: {
            display: displayTitle,
            text: "Largest Cities In " + location,
            fontSize: 25
          },
          legend: {
            display: displayLegend,
            position: legendPosition
          }
        }}
      />
    </div>
  );
};

export default ChartLine;
